export const disabledEvent = (event) => {
  event.preventDefault();
  console.log("The " + event.type + " event is disabled");
}

export const validatePostalCodeJp = (event) => {
  const key = event.key;
  const length = event.target.value.length;
  if(key >= '0' && key <= '9') {
    if(length === 3) {
      event.target.value += "-";
    }
    console.log("The key typed " + key + " is allowed");
  }
  else if((key == '-' && length === 3) || ['Delete','Backspace'].includes(key)) {
    console.log("The key typed " + key + " is allowed");
  }
  else {
    disabledEvent(event);
  }
}
